import {defineStyleConfig} from '@chakra-ui/react';

export const dividerTheme = defineStyleConfig({
  baseStyle: {
    borderColor: `stroke.primary`,
    opacity: 1,
  },
  defaultProps: {},
});
